import { memo } from "react";
import { Column } from "react-table";
import { CommentsTable } from "./Table";
import { getDateMonthFromTimestamp } from "@/lib/utils";
import { useAccessRequest } from "@/context/access-request-context";

const Comments = () => {
	const {
		isLoadingComments,
		comments,
		commentQueryPageIndex,
		commentQueryPageSize,
		setCommentQueryPageIndex,
		setCommentQueryPageSize,
	} = useAccessRequest();
	const commentHeader: Column<Comment>[] = [
		{
			Header: "Date",
			accessor: "time",
			Cell: ({ row }) => {
				return getDateMonthFromTimestamp(Number(row.original.time), "en");
			},
		},
		{
			Header: "Email",
			accessor: "userId",
		},
		{
			Header: "Note",
			accessor: "message",
		},
	];

	return (
		<>
			<CommentsTable<Comment>
				columnConfig={commentHeader}
				rowData={comments?.content || []}
				totalPages={comments?.totalPages}
				title="Comments"
				hideFilters
				loading={isLoadingComments}
				queryPageIndex={commentQueryPageIndex || 0}
				queryPageSize={commentQueryPageSize || 10}
				totalItems={comments?.totalElements}
				setQueryPageIndex={setCommentQueryPageIndex}
				setQueryPageSize={setCommentQueryPageSize}
			/>
      
		</>
	);
};

export default memo(Comments);
